export default __webpack_public_path__ + "static/media/singleCloseIcon.d311a572.svg";